export default __webpack_public_path__ + "locales/bg/SmartBanner.json?hash=5a1049e8953610f3a24eabca02236262";